 <template>
    <div id="GlAccountConfiguration">
        <div class="loader" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> GL Account Configuration List</div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content gl-account-configuration">
                        <data-table-filter-config :moduleName="'glAccountConfiguration'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'glAccountConfiguration'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listGlAccountConfigurationTable"
                                    mode="remote"
                                    title="GlAccountConfiguration"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: group_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Gl Account Configuration" v-if="canUpdate" class="fp-edit" v-bind:to="{name: 'GlAccountConfigurationEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="group_value" id="deleteGroupBtn" v-on:click.prevent="GlAccountConfigurationDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "GlAccountConfigurationList",
        components: {
            customPagination: () => import('@/components/layout/CustomPagination'),
            dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
            appFooter: () => import('@/components/Footer'),
        },
        metaInfo() {
            return {title: "Gl Account Configuration List | FleetPro Application"}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
             permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },
                {
                    label: 'Module',
                    field: 'module',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Module", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                  label: 'Key',
                  field: 'key',
                  filterable: true,
                  fpFieldType:"text",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Key", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: 'Code',
                  field: 'code',
                  filterable: true,
                  fpFieldType:"text",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                    label: 'Location Required',
                    field: 'location_required',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location Required", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['YES', 'NO'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                  label: 'Pool Required',
                  field: 'pool_required',
                  filterable: true,
                  hidden:false,
                  fpFieldType:"option",
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Pool Required", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['YES', 'NO'],
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
            ],
            rows: [],
            totalRecords: 0,
            group_value: false,
            loading:false,
            canUpdate:false,
            canAdd:false,
        }),
        created: function() {

        },
        watch:{
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name === "list_gl_account_configuration") {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name === "delete_gl_account_configuration") {
                            self.group_value = true;
                        }
                        if (permissions[i].name === "add_gl_account_configuration") {
                            self.canAdd = true;
                            self.canUpdate = true;
                        }
                    }
                }

            }
        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listGlAccountConfigurationTable.unselectAllInternal();
            },

            GlAccountConfigurationCreatePage(){
                var self = this;
                self.$router.push("/gl-account-configuration/create");
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/gl-account-configuration/list",
                    type: "POST",
                    data: fields,
                    headers:this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'group-list')
                    }
                });
            },
            GlAccountConfigurationDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Gl Account Configuration?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listGlAccountConfigurationTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listGlAccountConfigurationTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteGroupBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/gl-account-configuration/delete",
                          type: "POST",
                          data: 'id=' + use,
                          headers:this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                              $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteGroupBtn").val("Delete");
                              }, 10000);
                              self.rows = data.content.row;
                              if (data.code == '200') {
                                  self.rows = data.content.row;
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,true,'gl-account-configuration-delete')
                          }
                      });

                    } else {
                      console.log("no");
                    }
                });
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/GlAccountConfiguration.vue